module.exports = __webpack_public_path__ + "img/Dr_Bawumia.5fc0bf8b.jpg";